/**
 * Expected business errors that should be shown to users but not reported to Sentry.
 * These are validation errors from cart operations, not actual bugs.
 */
const EXPECTED_CART_ERROR_PATTERNS = [
	/is not available/i,
	/Cannot add items from different vendors/i,
	/Cannot add more than/i,
	/Cart total quantity exceeded/i,
	/Quantity must be a multiple of/i,
	/out of stock/i,
	/Expected number.*received nan/i,
	/Invalid quantity/i,
	// OTC pre-launch cart gate (OTC-24): an intentional block, not a bug.
	/cannot be added to the cart yet/i,
	// Accessory cannot open a new cart; it must attach to a pharmacy cart (OTC-42).
	/Cannot start a cart with an accessory/i,
	// Disabled-vendor gate on add-to-cart (MKP-1471): a stale page can still
	// target a pharmacy that was disabled meanwhile; the rejection is intended.
	/Vendor is currently unavailable/i,
];

/**
 * Determines if an error is an expected business validation error
 * that should be shown to users but not reported to Sentry.
 */
export const isExpectedCartError = (error: Error): boolean => {
	return EXPECTED_CART_ERROR_PATTERNS.some((pattern) =>
		pattern.test(error.message),
	);
};
